// Body.jsx - Enhanced Version
import React from 'react';
import './Body.css';
import { Link } from "react-router-dom";
import { FaGraduationCap, FaFileDownload, FaUserPlus } from 'react-icons/fa';

const Body = () => {
  const actionItems = [
    {
      icon: <FaGraduationCap />,
      title: "Courses Offered",
      link: "/Course",
      buttonText: "View Courses",
      color: "#003366"
    },
    {
      icon: <FaFileDownload />,
      title: "Admission 2026",
      link: "/AdmissionForm.pdf",
      buttonText: "Download Form",
      isDownload: true,
      color: "#4a6fa5"
    },
    {
      icon: <FaUserPlus />,
      title: "Apply Online",
      link: "/Contact",
      buttonText: "Apply Now",
      color: "#6b4e71"
    }
  ];

  return (
    <div className='quick-actions-container'>
      <div className='actions-grid'>
        {actionItems.map((item, index) => (
          <div 
            key={index} 
            className='action-card'
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className='card-icon' style={{ backgroundColor: item.color }}>
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            {item.isDownload ? (
              <a href={item.link} download className='action-btn'>
                {item.buttonText}
              </a>
            ) : (
              <Link to={item.link} className='action-btn'>
                {item.buttonText}
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Body;